export const META_CONNECT_TIMEOUT_MS = 55_000
export const META_MAX_CONNECT_ATTEMPTS = 3

export class ProviderConnectionError extends Error {
  constructor(
    message: string,
    readonly retryable: boolean,
    readonly statusCode?: string,
    readonly reason: 'declined' | 'unavailable' | 'provider' | 'connection' = 'connection'
  ) {
    super(message)
    this.name = 'ProviderConnectionError'
  }
}

function normalizedSipStatusCode(statusCode?: string) {
  return statusCode?.match(/\b\d{3}\b/)?.[0]
}

export function retryableSipFailure(statusCode?: string) {
  const code = normalizedSipStatusCode(statusCode)
  // A participant may disappear before LiveKit delivers its final SIP
  // attributes. Unknown pre-answer failures remain retryable; the SIP worker
  // now publishes the final status code so explicit declines stay terminal.
  if (!code) return true
  // Permission is validated before dialing. A 403 at this point can be the
  // transient SDP validation failure observed at Meta's SIP edge.
  return new Set(['403', '500', '502', '503', '504']).has(code)
}

export function sipFailureReason(statusCode?: string) {
  const code = normalizedSipStatusCode(statusCode)
  if (new Set(['486', '487', '600', '603']).has(code || '')) return 'declined' as const
  if (new Set(['404', '408', '410', '480', '484']).has(code || '')) return 'unavailable' as const
  return 'provider' as const
}

export async function waitBeforeRetry(attempt: number) {
  const delay = [0, 1_200, 3_000][attempt] ?? 3_000
  await new Promise<void>(resolve => window.setTimeout(resolve, delay))
}
